import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CalendarCustomer } from 'app/core/store/calendar/common/calendar.interface';

@Component({
  selector: 'app-calendar-legend',
  templateUrl: './calendar-legend.component.html',
  styleUrls: ['./calendar-legend.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush, // don't always check for changes, only when input changed (but there's no input here)
})
export class CalendarLegendComponent {
  @Input() customers: CalendarCustomer[] = [];
  @Output() customerSelected = new EventEmitter<CalendarCustomer>();

  constructor(private cd: ChangeDetectorRef) {}

  async selectCustomer(customer: CalendarCustomer) {
    this.customerSelected.emit(customer);
  }
}
